import axios from 'axios';
const { REACT_APP_API_URL } = global.APP_CONFIG;

const client = axios.create({
  baseURL: REACT_APP_API_URL,
});

export const uiAPI = axios.create({
  baseURL: '/api',
});

client.interceptors.request.use((config) => {
  if (config.params?.signal) {
    config.signal = config.params.signal;
    delete config.params.signal;
  }
  return config;
});

uiAPI.interceptors.response.use(
  (resp) => resp.data,
  (error) => {
    if (error.response?.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  },
);

export default client;
